import { useState } from "react";
import "./BannerUploadPopup.scss";

const BannerUploadPopup = ({ isOpen, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    stage: "Idea",
    image: null,
  });
  const [previewImage, setPreviewImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
        setFormData({ ...formData, image: reader.result });
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.image) {
      alert("Please upload an image");
      return;
    }
    
    setIsLoading(true);
    try {
      await onSubmit(formData);
      handleClose();
    } catch (error) {
      console.error("Error uploading banner:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setFormData({ stage: "Early", image: null });
    setPreviewImage(null);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="banner-upload-popup-overlay">
      <div className="banner-upload-popup">
        <div className="popup-header">
          <h2>Add Banner</h2>
          <button className="close-btn" onClick={handleClose}>
            ×
          </button>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Stage</label>
            <select
              value={formData.stage}
              onChange={(e) => setFormData({ ...formData, stage: e.target.value })}
            >
              <option value="Idea">Idea</option>
              <option value="Early">Early</option>
              <option value="Growth">Growth</option>
            </select>
          </div>
          
          <div className="form-group">
            <label>Upload Banner Image</label>
            <span className="image-recommendation">Recommended size: 1200 × 400 pixels (3:1 ratio) for optimal display</span>
            <div className="image-upload-container">
              {previewImage ? (
                <div className="preview-container">
                  <img src={previewImage} alt="Preview" className="preview-image" />
                  <button 
                    type="button" 
                    className="remove-image" 
                    onClick={() => {
                      setPreviewImage(null);
                      setFormData({ ...formData, image: null });
                    }}
                  >
                    ×
                  </button>
                </div>
              ) : (
                <div className="upload-area">
                  <input
                    type="file"
                    id="bannerImage"
                    accept="image/*"
                    onChange={handleImageChange}
                    className="file-input"
                  />
                  <label htmlFor="bannerImage" className="upload-label">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                      <polyline points="17 8 12 3 7 8"></polyline>
                      <line x1="12" y1="3" x2="12" y2="15"></line>
                    </svg>
                    <span>Choose an image or drag it here</span>
                  </label>
                </div>
              )}
            </div>
          </div>
          
          <div className="form-actions">
            <button type="button" className="cancel-btn" onClick={handleClose}>
              Cancel
            </button>
            <button 
              type="submit" 
              className="submit-btn" 
              disabled={isLoading || !formData.image}
            >
              {isLoading ? "Uploading..." : "Upload Banner"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BannerUploadPopup; 